import { Outlet } from "react-router-dom";
import "./App.css";
import { constants } from "./constants";
import MainContent from "./MainContent";

function App() {
  return (
    <div className="App">
      <div className="App-logo">
        <img src="worley-logo.svg" alt="worley" width="180px" />
      </div>
      <div className="App-header">
        <MainContent
          title={constants.title}
          description={constants.description}
          url={constants.url}
          btnText={constants.btnText}
        />
      </div>
    </div>
  );
}

export default App;
